import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";

const PodcastVideoContent = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center"
            pagination={{
              type: "bullets",
              el: ".pagination-progress",
              clickable: true,
            }}
            breakpoints={{
              1024: {
                slidesPerView: 1,
              },
            }}
            spaceBetween={20}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop
          >
            <SwiperSlide>
              <iframe
                width="100%"
                height="700"
                src="https://www.youtube.com/embed/2_kiQ8P8738?si=_IArinyZwMg8bc-T"
                title="YouTube video player3"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                width="100%"
                height="700"
                src="https://www.youtube.com/embed/5ThWkU3QqwE?si=d4KANWwwr88GKsbk"
                title="YouTube video player4"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                width="100%"
                height="700"
                src="https://www.youtube.com/embed/NSKAdzwD7Yw?si=TOVl5jd6SIbjTZpg"
                title="YouTube video player5"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="rounded-[16px]"
              ></iframe>
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination pagination-progress w-full relative z-10 py-5"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default PodcastVideoContent;
